import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/testimonials';
export function TestimonialsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-312" data-mp="1rtuxd76vx1hq">
      <SectionHeader eyebrow="What colleagues are saying" title="Feedback From Physiotherapists Who Value Structured Clinical Resources" data-id="element-313" data-mp="1mxcukcv47d81" />

      <div className="mx-auto mt-12 grid max-w-6xl gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-314" data-mp="1isn26xzo0grv">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-paper p-6 ring-1 ring-slate-200" data-id="element-315" data-mp="18wa6xvoh1uv0">
            <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-316" data-mp="13yihd8bauktz">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-317" data-mp="33ab7ckzo6px7" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 text-lg leading-relaxed text-slate-800" data-id="element-318" data-mp="1t9n5o6txjyfz">“{t.quote}”</blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-319" data-mp="1y8gkc2kydvhq">
              <img src={t.photo} alt={`${t.name}, ${t.role}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" data-id="element-320" data-mp="1y6ne2oe95da9" />
              <div data-id="element-321" data-mp="1oa0ue2xnws9t">
                <p className="font-display text-xl font-extrabold uppercase leading-tight text-ink" data-id="element-322" data-mp="1obbunsrwfhw6">{t.name}</p>
                <p className="text-sm text-slate-600" data-id="element-323" data-mp="2c0n0vps0q4hp">
                  {t.role} · {t.country}
                </p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <CtaButton label="I Want Access to the Complete Collection" sub="One-time payment of $27 · Instant access" data-id="element-324" data-mp="229scaeraust3" />
    </section>;
}